<template>
  <v-list style="background-color: transparent">
    
    <v-list-item v-for="(item, index) in menuItems" :key="index" :to="item.to">
      <v-list-item-avatar>
        <v-avatar
          size="40"
          color="defaultColorLightTwo"
          class="align-center justify-center"
        >
          <img
            :src="require(`@/../public/images/quickMenu/${item.image}`)"
            class="rounded-0"
            style="width: 18px; height: 18px"
          />
        </v-avatar>
      </v-list-item-avatar>
      <v-list-item-content class="defaultColor--text"> {{item.title}} </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  data: function () {
    {
      return {
        menuItems: [
          {
            image: "bornToday.png",
            to: "/bornTodayUsers",
            title: this.$t('menu.bornToday'),
          },
          {
            image: "newComers.png",
            to: "/newComers",
            title: this.$t('menu.newComers'),
          },
          {
            image: "bestOfBSP.png",
            to: "/bestOfUsers",
            title: this.$t('menu.bestOfBSP'),
          },
          {
            image: "thanks.png",
            to: "/thanksForm",
            title: this.$t('menu.thanks'),
          },
          {
            image: "surveys.png",
            to: "/surveyList",
            title: this.$t('menu.surveys'),
          },
        ],
      };
    }
  },
  props: {},
  mounted() {},
  methods: {},
  computed: {},
};
</script>
